import React, { useRef } from 'react';
import useBodyScrollLock from 'hooks/useBodyScrollLock';
import useCheckPC from 'hooks/useCheckPC';

const Loading = () => {
  const { isPC } = useCheckPC();

  const scrollableElRef = useRef(null);
  useBodyScrollLock(scrollableElRef);

  return (
    <div ref={scrollableElRef} className={'loading'}>
      <p>Please Wait</p>
    </div>
  );
};

export default Loading;
